import type { ApiResponse } from '@ay-shared-core/types/api'
import type { TokenResponse } from '@ay-shared-core/types/token'
import type { AdminModel } from '@ay-shared-core/types/admin'
import { API_PATH } from '@/config'
import request from '@/utils/request'

// 登录请求参数
export interface LoginRequest {
  username: string
  password: string
}

// 登录
export const login = async (data: LoginRequest): Promise<ApiResponse<TokenResponse>> => {
  const resp = await request.post<ApiResponse<TokenResponse>>(`${API_PATH}/admin/login`, data)
  return resp.data
}

// 刷新 Token（内部使用，添加特殊请求头避免刷新死循环）
export const refreshToken = async (): Promise<ApiResponse<TokenResponse>> => {
  const resp = await request.post<ApiResponse<TokenResponse>>(
    `${API_PATH}/admin/refresh-token`,
    {}, // 空对象作为 body
    {
      headers: {
        'X-Skip-Auth-Refresh': '1',
      },
    }
  )
  return resp.data
}

// 登出（清除服务端 Token）
export const logout = async (): Promise<ApiResponse<null>> => {
  const resp = await request.post<ApiResponse<null>>(`${API_PATH}/admin/logout`)
  return resp.data
}

// 获取当前用户信息
export const getProfile = async (): Promise<ApiResponse<AdminModel>> => {
  const resp = await request.get<ApiResponse<AdminModel>>(`${API_PATH}/admin/profile`)
  return resp.data
}

// 更新个人资料（nick_name + email）
export const updateProfile = async (data: { nick_name: string; email: string }): Promise<ApiResponse<null>> => {
  const resp = await request.put<ApiResponse<null>>(`${API_PATH}/admin/profile`, data)
  return resp.data
}

// 修改密码
export const changePassword = async (data: { old_password: string; new_password: string }): Promise<ApiResponse<null>> => {
  const resp = await request.put<ApiResponse<null>>(`${API_PATH}/admin/password`, data)
  return resp.data
}
